import { awsConfig } from '@config';
import queryString from 'query-string';
import { OAuthParams, REQUIRED_PARAMS } from './types';

export function validateRequiredOauthParams(input: string | Record<string, unknown>) {
  const params = typeof input === 'string' ? queryString.parse(input) : input;
  const missing = REQUIRED_PARAMS.filter((key) => !params[key]);
  return { params: params as OAuthParams, missing };
}

function buildOauthSearchParams(params: OAuthParams, identityProvider?: string): string {
  const {
    client_id,
    redirect_uri,
    response_type,
    state,
    scope,
    code_challenge,
    code_challenge_method,
  } = params;

  const urlParams = {
    client_id,
    redirect_uri,
    response_type,
    scope,
    state,
    code_challenge,
    code_challenge_method,
    ...(identityProvider && { identity_provider: identityProvider }),
  };

  return queryString.stringify(urlParams);
}

export function buildCognitoOauthUrl(params: OAuthParams, identityProvider: string): string {
  const base = `https://${awsConfig.Auth.oauth.domain}/oauth2/authorize`;

  return `${base}?${buildOauthSearchParams(params, identityProvider)}`;
}

export function buildCustomOauthUrl(params: OAuthParams): string {
  const base = `/authorize`;

  return `${base}?${buildOauthSearchParams(params)}`;
}
